<template>
  <div class="info-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "InfoCard"
};
</script>

<style lang="scss" scoped>
.info-card {
  border: 2px solid #2a63d5;
  padding: 14px;
  max-width: 420px;
  min-width: 400px;
}
</style>
